var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIconblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88704 7.00015L0.865237 1.97835C0.732759 1.84587 0.668226 1.68818 0.671637 1.50528C0.675059 1.32237 0.743009 1.16468 0.875487 1.03221C1.00796 0.899736 1.16565 0.833496 1.34855 0.833496C1.53145 0.833496 1.68914 0.899736 1.82162 1.03221L6.92547 6.14631C7.04598 6.26682 7.1353 6.40186 7.19342 6.55143C7.25153 6.70101 7.28059 6.85058 7.28059 7.00015C7.28059 7.14971 7.25153 7.29929 7.19342 7.44886C7.1353 7.59843 7.04598 7.73347 6.92547 7.85398L1.81137 12.9681C1.67889 13.1006 1.52291 13.1651 1.34342 13.1617C1.16394 13.1583 1.00796 13.0903 0.875487 12.9578C0.743009 12.8254 0.67677 12.6677 0.67677 12.4848C0.67677 12.3019 0.743009 12.1442 0.875487 12.0117L5.88704 7.00015Z",
    fill: "#373B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIconblack);
export default __webpack_public_path__ + "static/media/right_arrow_icon black.ef1119564ca83ec0aa252b805d4c0359.svg";
export { ForwardRef as ReactComponent };